import {HomeCardWithTitle} from '@/root/models/home';

interface Props {
  card: HomeCardWithTitle['groupedCards'][number];
  onChangeSelectedCards: (cardIds: Set<string>) => void;
  selectedCardIds: Set<string>;
}

const CardCheckbox = ({card, selectedCardIds, onChangeSelectedCards}: Props) => {
  const {cardId, title, expired} = card;
  const checked = selectedCardIds.has(cardId);

  const onChange = () => {
    if (checked) {
      selectedCardIds.delete(cardId);
    } else {
      selectedCardIds.add(cardId);
    }
    onChangeSelectedCards(selectedCardIds);
  };

  return (
    <div className="item_g item_check">
      <input type="checkbox" className="inp_g" aria-label={title} checked={checked} onChange={onChange} />
      <div className="wrap_lab">
        <span className="icon icon_input"></span>
        <label className="lab_g" aria-hidden="true">
          <span className="txt_lab">
            {title}
            {expired && (
              <>
                <span className="dot_desc">,</span> <span className="txt_red">만료</span>
              </>
            )}
          </span>
        </label>
      </div>
    </div>
  );
};

export default CardCheckbox;
